import React, { useEffect, useState } from 'react';
import { formatCurrency, formatTimestamp } from '../utlis/function';
import { useNavigate } from 'react-router-dom';
import { callApi } from '../services/ApiServices';
import CommonPagination from '../components/common/CommonPagination';
import { ImagePath } from '../components/common/ImagePath';
import CommonLoader from '../components/common/CommonLoader';
import ConfirmationModal from '../components/common/ConfirmationModal';
import toast from 'react-hot-toast';

const OrderManagement = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [ordersListing, setOrdersListing] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [cancelOrderId, setCancelOrderId] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);
  const limit = 10;
  const navigate = useNavigate()
  useEffect(() => {
    fetchOrders(currentPage, limit, searchQuery);
  }, []);

  const fetchOrders = async (page, limit, search) => {
    try {
          let ApiUrl = `admin/orders?page=${page}&limit=${limit}`;
          if (search) {
            ApiUrl += `&search=${search}`
          }
      if(!search){

        setLoading(true);
      }
      const response = await callApi({
        method: "get",
        url: ApiUrl,
      });
      console.log("orders", response);

      setOrdersListing(response?.data);
       const totalitems = response?.pagination?.total
    const totalPages = Math.ceil(totalitems / limit);
    setTotalCount(totalPages)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setLoading(false);
    }
  };

  const cancelSubscription = async () => {
    try {
      setCancelLoading(true);
      const response = await callApi({
        method: "put",
        url: `orders/cancel/${cancelOrderId}`,
        data: {},
      });
      toast.success(response?.message || "Subscription cancelled successfully");
      setCancelOrderId(null);
      fetchOrders(currentPage, limit, searchQuery);
    } catch (error) {
      console.log("error while cancelling subscription", error);
    } finally {
      setCancelLoading(false);
    }
  };

const handlePageChange =(e)=>{
  setCurrentPage(e)
  fetchOrders(e, limit, searchQuery)
}

  return (
    <div className="space-y-6">
   
      {/* Search Bar */}
      {loading && <CommonLoader fullScreen />}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 max-w-[314px]">
        <div className="relative">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textcolor"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            type="search"
            placeholder="Search by club Name..."
            value={searchQuery}
            onChange={(e) => {setSearchQuery(e.target.value)
              setCurrentPage(1)
              fetchOrders(1, limit, e.target.value)
            }}
              onKeyDown={(e) => {
              if (e.key === " " && searchQuery?.length === 0) {
                e.preventDefault();
              }
            }}
            className="w-full pl-10 pr-4 py-2.5 border-0 focus:outline-none text-base text-textcolor placeholder:text-textcolor"
          />
        </div>
      </div>
  

      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#fafafa] border-b border-gray-200">
              <tr>
                 <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Order ID
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Club Name
                </th>
               
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Advertiser
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Start Date
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  End Date
                </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Plan
                </th>
                   <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Subscription Fee
                </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Duration
                </th>
                 <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Geo target Fee
                </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Geo target Recurring Fee
                </th>
                 <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Design fee
                </th>
                 <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Daypart
                </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Amount
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {ordersListing?.length > 0 ? (
                ordersListing?.map((order, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                      <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {order?.id ? `#${order?.id}` : "-"}
                    </td>
                    <td className="px-6 py-3 ">
                         <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                          <img
                            src={order?.club?.clubLogoFile?.fileUrl}
                            alt="Avatar"
                            className="w-full h-full object-cover"
                          />
                          </div>
                         <span className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] line-clamp-1 max-w-[200px]">
                      {order?.club?.clubName || "-"}</span>
                        </div>
                    </td>
                   
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {order?.user?.name || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatTimestamp(order?.subscriptionStartDate) || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatTimestamp(order?.subscriptionEndDate) || "-"}
                    </td>
                     <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {order?.subscriptionDuration === 1 ? `${order?.subscriptionDuration} Month` : `${order?.subscriptionDuration} Months`}
                    </td>
                     <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {`${order?.totalSubscriptionFee || "-"}`}
                    </td>
                     <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {order?.displayDurationSeconds ? `${order?.displayDurationSeconds} sec` : "-"} 
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatCurrency(order?.geoTargetFee)  || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatCurrency(order?.geoTargetRecFee)  || "-"}
                    </td>
                     <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatCurrency(order?.designFee) || "-"}
                    </td>
                     <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {order?.daypart || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatCurrency(order?.totalAmount) || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor whitespace-nowrap">
                      {order?.orderStatus == 'ACTIVE' && !order?.cancelOn && (
                        'Active'
                      )}
                      {order?.orderStatus == 'ACTIVE' && order?.cancelOn && (
                        <span className="text-red-600">
                          Cancels on: {formatTimestamp(order?.cancelOn)}
                        </span>
                      )}
                      {order?.orderStatus == 'CANCELLED' && (
                        <span className="text-red-600">
                          Cancelled on: {formatTimestamp(order?.cancelledOn)}
                        </span>
                      )}
                      {order?.orderStatus != 'ACTIVE' && order?.orderStatus != 'CANCELLED' && "-"}
                    </td>
                    <td className="px-6 py-3">
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => {
                            navigate(
                              `/order-details/${order?.id}`,
                            );
                          }}
                          className="p-1 hover:bg-gray-100 rounded transition-colors cursor-pointer"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </button>
                       
                      </div>
                    </td>
           
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="15"
                    className="px-6 py-3 text-sm font-normal text-textcolor"
                  >
                    <div className="flex justify-center items-center mt-5">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2 text-center">No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
    
        </div>
      </div>
      <ConfirmationModal
        isOpen={Boolean(cancelOrderId)}
        title="Cancel Subscription"
        description="Are you sure you want to cancel this subscription? This action cannot be undone."
        confirmText="Yes, Cancel"
        cancelText="No"
        onConfirm={cancelSubscription}
        onCancel={() => setCancelOrderId(null)}
        isLoading={cancelLoading}
      />
      <CommonPagination
      currentPage={currentPage}
      pageCount={totalCount}
     onPageChange={(e) => handlePageChange(e)}

      />
    </div>
  );
};

export default OrderManagement;